import { useEffect, useState,useCallback } from "react";
import { usePagination } from "../../../hooks/usePagination";
import { format } from "date-fns";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { Card, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import FilterIcon from "../../svg/FilterIcon";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import ApiService from "../../../services/apiService";
import { method } from "lodash";
import { useNavigate } from "react-router-dom";
import Table from "../../table/Table";
import { Filter } from "react-feather";


const ActiveAlarms = () => {
    
    let updatedData :any =[] 
    const role = useAppSelector((state) => state.role.role)
    const userId = useAppSelector((state)=>state.user.userId);
    const[isModalOpen,setIsModalOpen] = useState(false);
    const[Remark,setRemark] = useState<string>('');
    const[selectedId,setSelectedId] = useState<number|string|null>()
    const navigate = useNavigate();
    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy
     } = usePagination({
        endpoint: `/alarms`,
        filterOn:'ChackName',
        enabled:true
       
     })
     const totalPages = Math.ceil(totalCount / pageSize);
  
     const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
     }, [setPageNumber, totalPages])
  
  
  
     const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
     }, [setPageNumber, totalPages])
  
     if(data){
           
         updatedData = data.map((time) =>{
         const alarmTimeDate =format(new Date(time.alarmTime ),'yyyy-MM-dd HH:mm:ss')
        const ackt = time.acknowledgeTime == null? '-' : format(new Date(time.acknowledgeTime  ),'yyyy-MM-dd HH:mm:ss')
         return{
            ...time,
             alarmTime:alarmTimeDate,
             acknowledgeTime:ackt,
             offTime:time.offTime ?  format(new Date(time.offTime), 'dd-MM-yyyy HH:mm:ss') : '-',
         }
        
  })
  }
  
  const handleAlarmsUpdate = (id: string) => {
        setSelectedId(id);
        setIsModalOpen(true)
  }

  const updateAlarms = async() =>{
       
    if(Remark&&selectedId){
           const updatedata = {
               AcknowledgeRemark : Remark,
               Id:selectedId,
               AcknowledgeBy:userId
           }
        const response = await ApiService.axiosApi(`/alarms/${selectedId}`,{
             method:'PUT',
             data: updatedata
        })
        if(response.success){
             setSelectedId(null)
             setRefresh(prev => !prev)
             setIsModalOpen(false)

        }
    }
  }


    return (

  <>
         <Breadcrumbs mainTitle={"Active Alarms"} parent={"Alarms"} />
         <div className="tables">
            <Card>
               <CommonCardHeader title="Alarms List" headClass="pb-3" />
               <div className="d-flex justify-content-between pb-2">
                    <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                       <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                         </div>

                         <div>
                        <button className="filter-button mx-2" style={{height:'30px'}} onClick={()=>setSortBy('ChackName')}>
                          <Filter/>
                      </button>
                      </div>
                      
                    </div>
               {role === "Administrator" && (
                  <div className="d-flex justify-content-end">

                  </div>
               )}
               </div>
               <Table
               
                  data={updatedData}
                  columns={[
                     { header: "Chak Name", accessor: "chakName" },
                     { header: "DistrbutaryZone", accessor: "distributaryZone" },
                     { header: "SchemeVillage", accessor: "schemeVillage" },
                     { header: "No. On/Of Valves", accessor: "no_Of_On_Of_Valves" },
                     {header: "Alarm Time", accessor:"alarmTime"},
                     {header:"Alarm", accessor:"alarm"},
                     {header:"Alarm OffTime", accessor:"offTime"},
                     {header:"Acknowledge By", accessor:"userName"},
                     {header:"Acknowledge Remark", accessor:"acknowledgeRemark"},
                     {header:"Acknowledge Time", accessor:"acknowledgeTime"}
                  ]}
                  buttons={[
                    { label: "Edit", onClick: handleAlarmsUpdate, color: "primary", className: "me-2" }
                  ]

                  }
               />
               <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                  <p style={{ marginRight: '10px', marginTop: '8px' }}>
                     Page {pageNumber} of {totalPages}
                  </p>
                  <button
                     onClick={handlePrev}
                     disabled={pageNumber === 1}
                     className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                  >
                     <LeftIcon className="icon" />
                  </button>
                  <button
                     className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                     onClick={handleNext}
                     disabled={pageNumber === totalPages}
                  >
                     <RightIcon className="icon" />
                  </button>
               </div>
            </Card>

            <Modal isOpen={isModalOpen}
             toggle={() => setIsModalOpen(!isModalOpen)}>
          <ModalHeader>
                Enter Remark
          </ModalHeader>
          <ModalBody>
              
              <Input
                 name="text"
                 type="textarea"
                 value={Remark}
                 onChange={(e:any) => setRemark(e.target.value)}
              />
             
          </ModalBody>
          <ModalFooter>
              <Button
              className='me-1'
              color='primary'
              size='sm'
                onClick={updateAlarms}
              >
                  Confirm
              </Button>

              <Button
              color='danger'
              size='sm'
               onClick={()=>setIsModalOpen(false)}
              >
                  Cancel
              </Button>
          </ModalFooter>
      </Modal>
            
         </div>
      </>
    )
}

export default ActiveAlarms;